import CompleteUserProfileForm from '../../Forms/CompleteUserProfileForm/CompleteUserProfileForm.component';

const ProfileCompletionModal = () => {
  return <CompleteUserProfileForm onSuccess={() => {}} />;
};

export default ProfileCompletionModal;
